import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
const store = createPinia();
store.use(piniaPluginPersistedstate);
/**
 *
 * @param { App } app
 */
export function setupStore(app) {
    app.use(store);
}
export default store;
//# sourceMappingURL=store.js.map